module.exports = __webpack_public_path__ + "static/img/file_sql.6f8df3f8.png";